
    import { Component, Vue} from 'vue-property-decorator';
    import PageBase from "@/components/steps/PageBase.vue";

    import Tooltip from "@/components/survey/Tooltip.vue";

    import { namespace } from "vuex-class";   
    import "@/store/modules/application";
    const applicationState = namespace("Application");
    import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages"

    @Component({
        components:{
            PageBase,
            Tooltip
        }
    })

    export default class NextSteps extends Vue {
        
        @applicationState.State
        public stPgNo!: stepsAndPagesNumberInfoType;

        @applicationState.Action
        public UpdateGotoPrevStepPage!: () => void

        @applicationState.Action
        public UpdateGotoNextStepPage!: () => void

        showLegalAssistance = false
        currentStep =0;
        currentPage =0;
        hasNeedPOselected = false
        showServeOtherParty = false
        
        regForeignSupportOrder = false;

        mounted(){ 
            this.hasNeedPOselected = false
            this.currentStep = this.$store.state.Application.currentStep;
            this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;

            const stepGETSTART = this.$store.state.Application.steps[this.stPgNo.GETSTART._StepNo]
            const stepPO = this.$store.state.Application.steps[this.stPgNo.PO._StepNo]

            this.regForeignSupportOrder = this.getRegForeignSupportOrderStatus()

            Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, 100, false);

            const includesOrderActivities = stepGETSTART.result?.selectedActivity.includes('applyForOrder');
            
            if( includesOrderActivities && stepGETSTART.result?.selectedForms?.includes('protectionOrder') && stepPO.result?.poQuestionnaireSurvey?.data?.orderType == 'needPO')  
                this.hasNeedPOselected =  true;
        }

        public getRegForeignSupportOrderStatus(){
            const stepENFRC = this.$store.state.Application.steps[this.stPgNo.ENFRC._StepNo]
            
            if(stepENFRC.active && stepENFRC.result?.enfrcQuestionnaireSurvey?.data?.includes('foreignSupport') )
                return true
            else
                return false
        }

        public onPrev() {
            Vue.prototype.$UpdateGotoPrevStepPage()
        }

        public onNext() {
            Vue.prototype.$UpdateGotoNextStepPage()
        }
    }
